import React, { Fragment } from "react";
import { noop } from "lodash";
import { useIsServerSideRender } from "@tvg/custom-hooks";
import { isTvg5 } from "@tvg/utils/generalUtils";

import {
  HeaderContainer,
  SpacingSpan,
  LogoButton,
  RedirectButton,
  ButtonWrapper,
  MiddleWrapper,
  InnerTitleWrapper,
  MidHeaderWrapper,
  RedirectButtonWrapper
} from "./styled-components";
import { getRegistrationProgress } from "../../_static/Constants/progressBar";

import Logo from "../../_static/Logos";
import Icon from "../../_static/Icons";
import { arrowBack } from "../../_static/Icons/icons";
import buildColor from "../../_static/ColorPalette";
import ParallelogramProgressBar from "../../_atom/ParalelogramProgressBar";

const HeaderRegistrationOrganism = (props) => {
  const {
    brand,
    redirectText,
    device,
    isWelcomePage,
    currentStep,
    handleBackButton,
    isFullSsn,
    handleClickAwayGtm,
    isWelcomeHeaderCollapsed,
    isEditing
  } = props;

  const { isServerSideRender } = useIsServerSideRender();

  const isMobile = device === "mobile";

  const currentStatus = getRegistrationProgress(currentStep);
  const items = [
    {
      text: "Account",
      width: 80,
      marginRight: 2,
      isSelected: currentStatus[0]
    },
    {
      text: "Address",
      width: 80,
      marginRight: 2,
      isSelected: currentStatus[1]
    },
    {
      text: "Verify",
      width: 80,
      isSelected: currentStatus[2]
    }
  ];

  const mobileRegularHeader = (
    <React.Fragment>
      <ButtonWrapper
        tabIndex={0}
        role="button"
        onClick={handleBackButton}
        isFullSsn={isFullSsn}
        data-qa-label="back-button-registration"
        isMobile={isMobile}
        isEditing={isEditing}
      >
        {!isWelcomeHeaderCollapsed && (
          <Icon
            icon={arrowBack}
            color={buildColor("white", "100")}
            qaLabel="back-button-registration-icon"
          />
        )}
      </ButtonWrapper>
      <MidHeaderWrapper isWelcomeHeaderCollapsed={isWelcomeHeaderCollapsed}>
        <LogoButton
          size="small"
          tag={isTvg5() ? "link" : "a"}
          url="/"
          qaLabel="logo-button"
          onClick={() =>
            handleClickAwayGtm
              ? handleClickAwayGtm("Logo", "Personal Details", "/")
              : null
          }
        >
          {!isServerSideRender && (
            <Logo brand={brand} data-qa-label="tvg-logo" />
          )}
        </LogoButton>
        {!isEditing && (
          <ParallelogramProgressBar
            qaLabel="registration-parallelogram"
            isShortened
            marginTop={14}
            type="GREEN"
            items={items}
          />
        )}
      </MidHeaderWrapper>
    </React.Fragment>
  );

  const tabletRegularHeader = isEditing ? (
    <React.Fragment>
      <MiddleWrapper>
        <InnerTitleWrapper>
          <ButtonWrapper
            tabIndex={0}
            role="button"
            onClick={handleBackButton}
            isFullSsn={isFullSsn}
            isMobile={isMobile}
            data-qa-label="back-button-registration"
          >
            <Icon
              icon={arrowBack}
              color={buildColor("white", "100")}
              qaLabel="back-button-registration"
            />
          </ButtonWrapper>
          <LogoButton
            size="small"
            tag={isTvg5() ? "link" : "a"}
            url="/"
            qaLabel="logo-button"
            onClick={() =>
              handleClickAwayGtm
                ? handleClickAwayGtm("Logo", "Personal Details", "/")
                : null
            }
          >
            {!isServerSideRender && (
              <Logo brand={brand} data-qa-label="tvg-logo" />
            )}
          </LogoButton>
          <span />
        </InnerTitleWrapper>
      </MiddleWrapper>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <MiddleWrapper>
        <LogoButton
          size="small"
          tag={isTvg5() ? "link" : "a"}
          url="/"
          qaLabel="logo-button"
          onClick={() =>
            handleClickAwayGtm
              ? handleClickAwayGtm("Logo", "Personal Details", "/")
              : null
          }
        >
          {!isServerSideRender && (
            <Logo brand={brand} data-qa-label="tvg-logo" />
          )}
        </LogoButton>
        <InnerTitleWrapper>
          <ButtonWrapper
            tabIndex={0}
            role="button"
            onClick={handleBackButton}
            isFullSsn={isFullSsn}
            isMobile={isMobile}
            data-qa-label="back-button-registration"
          >
            <Icon
              icon={arrowBack}
              color={buildColor("white", "100")}
              qaLabel="back-button-registration"
            />
          </ButtonWrapper>
          <ParallelogramProgressBar
            qaLabel="registration-parallelogram"
            isShortened
            type="GREEN"
            items={items}
          />
          <span />
        </InnerTitleWrapper>
      </MiddleWrapper>
    </React.Fragment>
  );

  const renderWelcomePage = isWelcomeHeaderCollapsed ? (
    mobileRegularHeader
  ) : (
    <React.Fragment>
      <SpacingSpan />
      <LogoButton
        size="small"
        tag={isTvg5() ? "link" : "a"}
        url="/"
        qaLabel="logo-button"
        onClick={() =>
          handleClickAwayGtm
            ? handleClickAwayGtm("Logo", "Personal Details", "/")
            : null
        }
      >
        {!isServerSideRender && <Logo brand={brand} data-qa-label="tvg-logo" />}
      </LogoButton>
    </React.Fragment>
  );

  return (
    <HeaderContainer
      isWelcomePage={isWelcomePage && !isWelcomeHeaderCollapsed}
      isEditing={isEditing}
    >
      {isWelcomePage ? (
        <React.Fragment>{renderWelcomePage}</React.Fragment>
      ) : (
        <React.Fragment>
          {device === "mobile" ? mobileRegularHeader : tabletRegularHeader}
        </React.Fragment>
      )}

      {isWelcomePage && !isWelcomeHeaderCollapsed && (
        <Fragment>
          {redirectText ? (
            <RedirectButtonWrapper>
              <RedirectButton
                tag={device === "desktop" && !isTvg5() ? "a" : "link"}
                url={isTvg5() ? "/#login" : "/login"}
                qaLabel="redirect-button"
                onClick={() =>
                  handleClickAwayGtm
                    ? handleClickAwayGtm("Login", "Personal Details", "/#login")
                    : null
                }
              >
                {redirectText}
              </RedirectButton>
            </RedirectButtonWrapper>
          ) : (
            <SpacingSpan />
          )}
        </Fragment>
      )}
    </HeaderContainer>
  );
};

HeaderRegistrationOrganism.defaultProps = {
  redirectText: "",
  handleRedirectButton: noop,
  isWelcomePage: false,
  handleBackButton: noop,
  currentStep: "WELCOME",
  isFullSsn: false,
  handleClickAwayGtm: noop,
  isWelcomeHeaderCollapsed: false
};

export default HeaderRegistrationOrganism;
